import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionList from '../../components/SelectionList/SelectionList';
import useMarketDisplayLimit from '../../hooks/useMarketDisplayLimit';

const List: MarketTemplateComponent<
  SingleMarketTemplateProps & {
    showPreviousPrice?: true;
  }
> = ({ marketId, showPreviousPrice }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));

  const [runnersToDisplay, handleShowMoreClick, limitRunners] = useMarketDisplayLimit(
    market?.runners ?? [],
    marketId
  );

  if (!market) return null;
  return (
    <SelectionList market={market} data-testid="market-template-list">
      {runnersToDisplay.map((runner) => (
        <SelectionList.Item
          key={runner.selectionId}
          runner={runner}
          showPreviousPrice={showPreviousPrice}
        />
      ))}
      {limitRunners && <SelectionList.ShowMoreButton onClick={handleShowMoreClick} />}
    </SelectionList>
  );
};

List.marketTemplateType = 'BASE';

export default List;
